module.exports = {
  apiKey: "AIzaSyBzYy8Nb0wN4wmB_wNlTOLrbSQUTwHqMZM",
  authDomain: "encadyma-prism-dev.firebaseapp.com",
  databaseURL: "https://encadyma-prism-dev.firebaseio.com",
  projectId: "encadyma-prism-dev",
  storageBucket: "encadyma-prism-dev.appspot.com",
  messagingSenderId: "294058600281"
}



//////////////////
// WEBPACK FOOTER
// ./config/firebase.js
// module id = YWcn
// module chunks = 1